import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import BREAKPOINT from 'assets/styles/breakpoints';
import { COLOR } from 'assets/styles/colors';

export const Container = styled.div`
  // min-width: 320px;
  height: auto;
  // background-color: #e3f0fc;
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .MuiSvgIcon-root {
    width: 22px;
    height: 22px;
  }
`;

export const Wrapper = styled.div`
  min-width: 320px;
  max-width: 616px;
  height: auto;
  background-color: #fff;
  padding: 24px 18px;
  margin-right: auto;
  margin-left: auto;
  .MuiIconButton-label {
    font-weight: 500;
    font-size: 16px;
    text-decoration: underline;
  }
      /* Tablet-Notebook */
      @media screen and (min-width: ${BREAKPOINT.MD}) {
      .MuiIconButton-label {
        font-size: 18px;
      }
    }
    @media screen and (min-width: ${BREAKPOINT.LG}) {
      .MuiIconButton-label {
        font-size: 20px;
      }
    }
`;

export const TitleText = styled.h2`
    margin: 0;
    font-weight: bold;
`;

export const DescriptionText = styled.p`
    margin: 10px 0;
`;

export const LinkText = styled.a`
    margin: 0;
    color: #000;
`;

export const ContainerExtract = styled.div`
    display: flex;
    margin-top: 30px;
`;

export const ButtonCalculate = styled.button`
    width: 50%;
    margin: 6px;
    height: 36px;
`;

export const ContainerButtons = styled.div`
    display: flex;
`;

export const Table = styled.table`
  width: 100%;
  margin: 6px 0px 32px 0;
  color: ${COLOR.GREY_1};

  thead {
    font-family: Barlow;
    font-weight: 400;
    font-size: 16px;

    tr:first-child {
      th, td {
        padding-top: 18px;
      }
    }
  }

  tbody {
    font-size: 16px;
    border-bottom: 1px solid #C8CBD4;
    tr:last-child {
      th, td {
        padding-bottom: 32px;
      }
    }
  }

  th, td {
    text-align: left;
    padding: 7px 0;
  }

  td {
    word-break: break-word;
    line-height: 1.4;
    width: 15%;
  }

  button {
    color: #000;
  }

  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    thead {
      font-size: 18px;
    }

    tbody {
      font-size: 18px;
    }
  }
  /* Desktop 2 */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    thead {
      font-size: 20px;
    }

    tbody {
      font-size: 20px;
    }
  }
`;

export const Styles = makeStyles({
  button: {
    width: 100,
  },
  text: {
    marginTop: 0,
    marginBottom: 26,
    fontWeight: 500,
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between',
  },
  buttonCompra: {
    width: '100% !important',
    margin: '6px 0px',
  },
  valueText: {
    color: COLOR.GREEN_1,
    fontWeight: 500,
  },
});

export const Negative = styled.span`
  color: ${COLOR.RED_3};
  text-decoration: line-through;
  svg {
    width: 15px;
    height: 15px;
    margin: 8px;
  }
`;

export const TextHelp = styled.p`
  font-size: 18px;
  font-weight: 500;
  color: ${COLOR.GREEN_1};
  text-decoration: underline;
  text-align: center;
  margin-top: 18px;
  margin-bottom: 46px;
  cursor: pointer;
  /* Tablet-Notebook */
  @media screen and (min-width: ${BREAKPOINT.MD}) {
    font-size: 20px;
  }
  /* Desktop 2 */
  @media screen and (min-width: ${BREAKPOINT.LG}) {
    font-size: 22px;
  }
`;
